const organization = {
    title: "Organización",
      search: "Buscar Organizaciones...",
      noOrganizations: "No eres parte de alguna organización",
      file: "Archivo"
}

export default organization;